import { Modal, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { message } from "antd";
import { platformApi } from "../../../../api";
import React from "react";

function AadharUploadModal({ open, close, customerId, onUploaded }) {

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const uploadAadhar = () => {
    if (!file) return message.error("Please upload Aadhar image");

    const formData = new FormData();
    formData.append("aadhar", file);
    formData.append("customerId", customerId);
    setLoading(true);

    platformApi.post("/api/customer/aadharUpload", formData)
      .then(res => {
        setLoading(false);
        message.success("Aadhar uploaded & customer updated");
        onUploaded();
        close();
      })
      .catch(() => {
        setLoading(false);
        message.error("Upload failed");
      });
  };

  const closeModal = () => {
    setFile(null);
    close();
  }

  return (
    <Modal
      visible={open}
      onCancel={
        ()=>closeModal()
    }
      title="Upload Aadhar"
      footer={[
        <Button key="cancel" onClick={close}>Cancel</Button>,
        <Button key="upload" type="primary" loading={loading} onClick={uploadAadhar}>
          Upload
        </Button>
      ]}
    >
      <Upload
        beforeUpload={(file) => {
          setFile(file);
          return false;
        }}
      >
        <Button icon={<UploadOutlined />}>Choose Aadhar File</Button>
      </Upload>
    </Modal>
  );
}
export default AadharUploadModal;